
export interface GspService {
    id: number; // int
    name: string; // string
    // roles: any // System.Collections.Generic.ICollection<adminPanel.DataAccessPostgreSQL.Database.DataModel.GspRole>;
    modules: any // System.Collections.Generic.ICollection<adminPanel.DataAccessPostgreSQL.Database.DataModel.GspModuleDm>;
    created: string; // System.DateTime?
    creatorId: string; // string
    creatorEmail: string; // string
    zrType: number; // byte
    entra_Group: string; // string
    sort: number; // ushort = smallint (up to 32000)
    key: string; // string
    tooltip: string; // string
    isHideInProd: boolean; // bool


    short_common_text: string; // string
    is_call_zr_master: boolean; // (AD-103) for now purely backend field, don't show on form for now
    modulesNames: string; // string (AD-0)

    contact_types: any;
    contactTypeIds: Array<Number> | undefined;
}

export interface Value {
  value: GspService[];
  '@odata.context'?: string | undefined;
  '@odata.count'?: number | undefined;
}

// init api object
function toAPI(data: Partial<GspService>): any {
  return {
    Id: data?.id || 0,
    Name: data?.name || '',
    // Roles: data?.roles || [],
    Modules: data?.modules || undefined,
    Created: data?.created || undefined,
    CreatorId: data?.creatorId || undefined,
    CreatorEmail: data?.creatorEmail || undefined,
    ZrType: data?.zrType || 0,
    Entra_Group: data?.entra_Group || undefined,
    Short_common_text: data?.short_common_text || undefined,
    Is_call_zr_master: data?.is_call_zr_master || false,
    Sort: data?.sort || 0,
    Key: data?.key ?? undefined,
    Tooltip: data?.tooltip || '',
    IsHideInProd: data?.isHideInProd || false,

    Contact_types: data?.contact_types || undefined,
    ContactTypeIds: data?.contactTypeIds || undefined,
  };
}

function parse(data?: Partial<GspService>): GspService {
  return {
    id: data?.id || 0,
    name: data?.name || '',
    // roles: data?.roles || '',
    modules: data?.modules || '',
    created: data?.created || '',
    creatorId: data?.creatorId || '',
    creatorEmail: data?.creatorEmail || '',
    zrType: data?.zrType || 0,
    entra_Group: data?.entra_Group || '',
    short_common_text: data?.short_common_text || '',
    is_call_zr_master: data?.is_call_zr_master || false,
    sort: data?.sort || 0,
    key: data?.key || '',
    tooltip: data?.tooltip || '',
    isHideInProd: data?.isHideInProd || false,


    contact_types: data?.contact_types || '',
    contactTypeIds: data?.contact_types ? data?.contact_types?.map((x:any) => x.id) : undefined,
    modulesNames: data?.modulesNames || '',
  };
}

export default {
  parse,
  toAPI: toAPI,
};
